import { render, staticRenderFns } from "./Waterfall.vue?vue&type=template&id=2722665e&"
import script from "./Waterfall.vue?vue&type=script&lang=js&"
export * from "./Waterfall.vue?vue&type=script&lang=js&"
import style0 from "./Waterfall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports